import { render, staticRenderFns } from "./ApiDomain.vue?vue&type=template&id=1fe8961c"
import script from "./ApiDomain.vue?vue&type=script&lang=js"
export * from "./ApiDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports